// @ts-nocheck

import React, { Component } from 'react';
import Input from 'antd/lib/input/Input';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';


import { Popconfirm, Icon, ListTable } from './../../../components/ui';
import { InputNumber } from '../../../components/inputs';
import { withEmptyRow } from '../../../lib/helpers';
import { cargoApi } from '../../../lib/api';

const StyledIcon = styled(Icon).withConfig({ displayName: "CargosForm__StyledIcon", componentId: "sc-gqpz3-0" })(["cursor:pointer;"]);


const Operations = styled.div.withConfig({ displayName: "CargosForm__Operations", componentId: "sc-gqpz3-1" })(["display:flex;align-items:center;justify-content:center;height:100%;"]);











/**
 * Компонент отображает список прикрепленных к заявке по доп. найму ТС грузов
 */
class CargosForm extends Component {
  static defaultProps = {
    cargos: []
  };

  onChange(index, key, value) {
    let cargos = withEmptyRow([...this.props.cargos]);
    cargos.splice(index, 1, {
      ...cargos[index],
      [key]: value
    });
    this.props.onChange(cargos);
  }

  onDelete(index) {
    this.props.onChange(this.props.cargos.filter((value, id) => id !== index));
  }

  render() {
    const { cargos } = this.props;
    return (
      <ListTable
        columns={[
        {
          title: 'Наименование',
          dataIndex: 'name',
          key: 'name',
          render: (name, record, index) =>
          <Input
            onChange={(e) => this.onChange(index, 'name', e.target.value)}
            value={name}
            name="name"
            placeholder="Введите наименование" />


        },
        {
          title: 'Количество мест, общ',
          key: 'placeNumber',
          width: '90px',
          render: (placeNumber, record, index) =>
          <InputNumber
            onChange={(value) =>
            this.onChange(index, 'placeNumber', value)
            }
            value={placeNumber}
            name="placeNumber" />


        },
        {
          title: 'Общий вес, кг',
          key: 'totalWeight',
          width: '90px',
          render: (totalWeight, record, index) =>
          <InputNumber
            onChange={(value) =>
            this.onChange(index, 'totalWeight', value)
            }
            value={totalWeight}
            name="totalWeight" />


        },
        {
          title: 'Вид упаковки',
          dataIndex: 'packageType',
          key: 'packageType',
          render: (packageType, record, index) =>
          <Input
            onChange={(e) =>
            this.onChange(index, 'packageType', e.target.value)
            }
            value={packageType}
            name="packageType"
            placeholder="Введите вид упаковки" />


        },
        {
          width: '20px',
          renderRecord: (cargo, index) =>
          !isEmpty(cargo) ?
          <Operations>
                  {cargo.id ?
            <Popconfirm
              title="Вы уверены, что хотите удалить груз?"
              onConfirm={async () => {
                if (cargo.id) await cargoApi.deleteCargo(cargo.id);
                this.onDelete(index);
              }}>

                      <StyledIcon type="x" />
                    </Popconfirm> :

            <StyledIcon onClick={() => this.onDelete(index)} type="x" />
            }
                </Operations> :
          null
        }]
        }
        data={withEmptyRow(cargos)} />);


  }
}

export default CargosForm;